import { ReactElement, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ProjectFormModel } from '@app/modules/projects/inputs/project-admin/project-form/project-form-types';
import styles from './tabs.module.scss';

import TabTitle from './TabTitle/TabTitle';

type Props = {
  children: ReactElement[];
  preSelectedTabIndex?: number;
  formMethods: UseFormReturn<ProjectFormModel, any, undefined>;
  setName: any;
};

const Tabs = (props: Props): JSX.Element => {
  const { children, preSelectedTabIndex, formMethods, setName } = props;

  // First tab is shown by default
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(preSelectedTabIndex ?? 0);

  return (
    <div>
      <ul className={styles.ull}>
        {children.map((item, index) => (
          <TabTitle
            formMethods={formMethods}
            key={item.props.value}
            title={item.props.title}
            value={item.props.value}
            index={index}
            isActive={index === selectedTabIndex}
            setSelectedTab={setSelectedTabIndex}
            setName={setName}
          />
        ))}
      </ul>
      {/* show selcted tab by index*/}
      {children[selectedTabIndex]}
    </div>
  );
};

export default Tabs;
